import { message } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createUser } from "@/lib/api/resources/users";
import { useNavigate } from "react-router-dom";
import { UserForm, UserFormValues } from "./components/UserForm";
import { Card } from "@rumbledirect/ui";

export const UserCreate = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: createUser,
    onSuccess: () => {
      message.success("Gebruiker aangemaakt");
      queryClient.invalidateQueries({ queryKey: ["users"] });
      navigate("/users");
    },
    onError: () => message.error("Gebruiker aanmaken mislukt"),
  });

  const submit = (values: UserFormValues) => {
    mutation.mutate(values);
  };

  return (
    <Card className="max-w-xl w-full" title="Nieuwe gebruiker">
      <UserForm
        loading={mutation.isPending}
        submitLabel="Aanmaken"
        onSubmit={submit}
      />
    </Card>
  );
};
